<template>
  <div class="week-calendar-times" :style="{ height: `${calendarHeight}px` }">
    <div
      v-for="slot in timeSlots"
      :key="slot.key"
      class="week-calendar-time"
      :class="{ 'week-calendar-time--with-label': slot.label }"
      :style="{ height: `${slotHeight}px` }"
    >
      <span v-if="slot.label">{{ slot.label }}</span>
    </div>
    <div
      v-if="currentTimeStyle"
      class="week-calendar-current-time"
      :style="currentTimeStyle"
    >
      <span class="week-calendar-current-time-label">{{ currentTimeLabel }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WeekCalendarTimes',
  props: {
    calendarHeight: {
      type: Number,
      required: true,
    },
    slotHeight: {
      type: Number,
      required: true,
    },
    timeSlots: {
      type: Array,
      required: true,
    },
    currentTimeStyle: {
      type: Object,
      default: null,
    },
    currentTimeLabel: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss">
@import 'src/assets/scss/variables';

.week-calendar-times {
  display: flex;
  flex-direction: column;
  grid-column: 1 / 2;
  grid-row: 2 / 3;
  background-color: $light-color;
  border-bottom: $border-width solid $border-color;
  position: relative;
}

.week-calendar-time {
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  font-size: $font-size-xs;
  color: $gray-color-dark;
  padding-right: 0.25rem;
  position: relative;
}

.week-calendar-time--with-label span {
  position: absolute;
  top: 0;
  right: 0.25rem;
  line-height: 1;
  transform: translateY(-50%);
}

.week-calendar-times > .week-calendar-time:first-child.week-calendar-time--with-label span {
  top: 0.5rem;
}

.week-calendar-current-time {
  position: absolute;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  pointer-events: none;
  z-index: 10;
  padding-right: 0.25rem;
  transform: translateY(-50%);
}

.week-calendar-current-time-label {
  background-color: $error-color;
  color: $light-color;
  font-size: 11px;
  font-weight: 500;
  padding: 2px 6px;
  border-radius: $border-radius;
  white-space: nowrap;
}
</style>
